var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "48px",
    viewBox: "0 0 82 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Willkommen-02",
    transform: "translate(-681.000000, -177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay",
    transform: "translate(411.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Intro",
    transform: "translate(1.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_sample",
    transform: "translate(269.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "BVG",
    fontFamily: "Inter-Bold, Inter",
    fontSize: 38.4,
    fontWeight: "bold",
    "line-spacing": 36.2666667,
    letterSpacing: -0.225882355,
    fill: "#263238"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 37
  }, "BVG")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1B8DB3",
    x: 2.13333333,
    y: 42.6666667,
    width: 77.8666667,
    height: 5.33333333
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.039f25eb.svg";
export { ForwardRef as ReactComponent };